define('GameDayCore/GDModel/ValueObjects/Bench/BenchPitcher',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(BenchPitcher);

	function BenchPitcher($data, $team) {
		var vo = VO.ensureVO(this, BenchPitcher),
			data = $data;

		vo.id = data.id || "";
		vo.last = data.last || "";
		vo.team = $team;
		vo.t = data.t || "";
		vo.w = data.w || "";
		vo.l = data.l || "";
		vo.era = data.era || "";
		vo.g = data.g || "";
		vo.sv = data.sv || "";
		vo.ip = data.ip || "";
		vo.h = data.h || "";
		vo.bb = data.bb || "";
		vo.so = data.so || "";
	}

	return BenchPitcher;
});
